import { initReactI18next } from 'react-i18next';

import i18next from 'i18next';

import LANGUAGE_FILE_EN from './languages/en';
import LANGUAGE_FILE_TR from './languages/tr';
import LANGUAGE_FILE_UK from './languages/uk';

i18next.use(initReactI18next).init({
	lng: 'en',
	resources: {
		en: { translation: LANGUAGE_FILE_EN },
		tr: { translation: LANGUAGE_FILE_TR },
		uk: { translation: LANGUAGE_FILE_UK },
	},
	fallbackLng: 'en',
	defaultNS: 'translation',
	interpolation: {
		escapeValue: false,
	},
});

export default i18next;
